import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsAndroidstudioComponent } from './simple-icons-androidstudio.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsAndroidstudioComponent ],
    exports:      [ SimpleIconsAndroidstudioComponent ],
    bootstrap:    []
})
export class SimpleIconsAndroidstudioModule {}
